import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import Confetti from 'react-confetti';
import Section from '../../../containers/Section';
import { useWindowSize } from '../../../hooks/useWindowSize';
import GradientTitle from '../../GradientTitle';
import { HeaderVariant } from '../../Header';
import Paragraph from '../../Paragraph';
import SelectableButton from '../../SelectableButton';
import Testimonal from '../../Testimonial';
import GoalConfigPanel, { GoalConfigPanelVariant } from './GoalConfigPanel';
interface GoalProps {
  title: string[];
  gradientPosition: number;
  description: string;
  backgroundImage: any;
  features?: any;
  testimonialsDescription?: string;
  testimonialsPerson?: string;
  testimonialsPersonTitle?: string;
  page?: string;
}

const GoalSection: React.FC<GoalProps> = props => {
  const {
    title,
    gradientPosition,
    description,
    backgroundImage,
    features,
    testimonialsDescription,
    testimonialsPerson,
    testimonialsPersonTitle,
    page,
  } = props;
  const data = useStaticQuery(graphql`
    query {
      headshot: file(relativePath: { eq: "headshots/daniel-zakowski.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      productImage: file(relativePath: { eq: "index/product-list.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `);

  const [selectedGoalFeature, setSelectedGoalFeature] =
    React.useState<GoalConfigPanelVariant>(features && features[1]);

  const [showConfetti, setShowConfetti] = React.useState(false);

  const launchGoal = () => {
    setTimeout(() => {
      setShowConfetti(true);
    }, 500);
  };

  const size = useWindowSize();

  const testimonal = (
    <Testimonal
      quote={testimonialsDescription}
      name={testimonialsPerson}
      role={testimonialsPersonTitle}
      image={data?.headshot?.childImageSharp?.gatsbyImageData}
    />
  );

  return (
    <Section>
      <div className="pt-20 lg:pt-32 pb-20 lg:pb-40 flex flex-col-reverse lg:flex-row lg:items-center">
        <div className="block mt-8 md:mt-20 lg:hidden">{testimonal}</div>
        <div className="relative flex items-center justify-start lg:w-1/2">
          <GatsbyImage
            image={backgroundImage}
            alt="product list"
            className="w-72 md:w-96 z-0 my-6 lg:my-0"
          />
          <div className="absolute -right-10 md:right-3 lg:right-16 scale-75 md:scale-100">
            <GoalConfigPanel
              feature={selectedGoalFeature}
              page={page}
              onClick={launchGoal}
            />
          </div>
          {showConfetti && (
            <div className="fixed top-0 left-0 w-full h-screen">
              <Confetti
                colors={[
                  '#8241F3',
                  '#42A5F5',
                  '#D2BBFB',
                  '#F5F0FE',
                  '#BBDFFB',
                  '#F0F8FE',
                ]}
                style={{ position: 'fixed' }}
                width={size.width}
                height={size.height}
                run={showConfetti}
                recycle={false}
                numberOfPieces={1000}
                onConfettiComplete={() => setShowConfetti(false)}
              />
            </div>
          )}
        </div>
        <div className="text-center lg:text-left lg:w-1/2">
          <GradientTitle
            gradientPosition={gradientPosition}
            className="md:max-w-md mx-auto lg:mx-0"
            color="purple"
            variant={HeaderVariant.h2}
            title={title}
            lineBreak={false}
          />
          <Paragraph className="text-2xl">
            {description && description}
          </Paragraph>
          <div className="flex flex-wrap items-center justify-center space-x-4 mt-4 mb-8 md:mb-20 lg:mb-11 lg:justify-start">
            {features &&
              features?.map(item => {
                return (
                  <SelectableButton
                    key={item.id}
                    className="mt-4"
                    text={item?.name}
                    active={selectedGoalFeature == item}
                    onClick={() => {
                      setSelectedGoalFeature(item);
                    }}
                  />
                );
              })}
          </div>
          <div className="hidden lg:block">{testimonal}</div>
        </div>
      </div>
    </Section>
  );
};

export default GoalSection;
